import React from "react";
import "./WhyChooseUsSection.css";
import { whyChoosevanijyamData } from "../../../data/whyChooseUsData";

import {
  FaBuilding,
  FaMoneyBillWave,
  FaLock,
  FaStore,
  FaTruck,
  FaUsers,
  FaHandshake,
  FaSeedling,
  FaStar,
  FaGlobe, FaLeaf,
    FaCertificate,   // for Organic & Natural Choices
    FaLightbulb,     // for Pooja Essentials (light/spiritual)
    FaBook,          // for Spiritual Books
    FaCheckCircle,   // for Verified Sellers
    FaRecycle,        // for Eco-Aware Practices
    FaPrayingHands
} from "react-icons/fa";

const IconMap = {
  IconTemple: FaBuilding,
  IconMoney: FaMoneyBillWave,
  IconLock: FaLock,
  IconStore: FaStore,
  IconTruck: FaTruck,
  IconNoMiddleman: FaHandshake,
  IconCommunity: FaUsers,
  IconGrowth: FaSeedling,
  IconQuality: FaStar,
  IconGlobal: FaGlobe,
    IconLeaf: FaLeaf,
    IconCertificate:FaCertificate,
    IconLight: FaLightbulb,
    IconBook: FaBook,
    IconVerified: FaCheckCircle,
    IconEco: FaRecycle,
    IconPray: FaPrayingHands,
    IconSeedling: FaSeedling
};

const WhyChooseUsCard = ({ icon, title, description }) => {
  const IconComponent = IconMap[icon];
  return (
    <div className="why-choose-us-section feature-item">
      {IconComponent && (
        <div className="feature-icon">
          <IconComponent className="feature-icon_" />
        </div>
      )}
      <div className="why-choose-text-content">
        <h3 className="why-choose-title " style={{ textAlign: "center" }}>
          {title}
        </h3>
        <p className="why-choose-description" style={{ textAlign: "center" }}>
          {description}
        </p>
      </div>
    </div>
  );
};

const WhyChooseUsSection = () => {
  const { heading, subtitle, benefits } = whyChoosevanijyamData;

  return (
    <section className="page-section why-choose-us-section">
      <h2 className="_hTitle_s5E_ section-title">{heading}</h2>
      <p
        className="workflow-subtitle _hSubtitle_t6F_"
        style={{ marginTop: "0px", paddingBottom: "0px" }}
      >
        {subtitle ||
          "Discover the core benefits of partnering with Vanidya, where tradition meets technology."}
      </p>

      <div className="why-choose-flex-container">
        {benefits.map((benefit) => (
          <WhyChooseUsCard
            key={benefit.title}
            icon={benefit.icon}
            title={benefit.title}
            description={benefit.description}
          />
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
